export default {
    buyAdditional: '郵送ポイントを購入する',
    description:
        '郵送ポイントで日本国内の郵送代行サービスを利用できます。1郵送ポイントで5ページまで封入できます。（1回の郵送につき最大200ページまで）',
    descriptionTitle: '郵送ポイント',
    enterAmount: '数量を直接入力',
    manualInput: 'マニュアル入力',
    manualInputError: {
        max: 'この値は {{max}} 以下でなければなりません。',
        min: 'この値は {{min}} 以上でなければなりません。',
    },
    pricePer: '{{price}}（税抜）/ 1郵送ポイント',
    proceed: '  次へ（確認画面）',
    selectAmount: '数量を選択',
    submitButton: {
        error: 'エラー',
        helperText: '数量を選択、又は入力してください({{min}}-{{max}})',
        loading: 'ロード',
        plusTax: '{{value}}（税抜）',
        submit: '次へ（確認画面）',
    },
    tenMailpoints: '10 郵送ポイント',
    title: '郵送ポイントの購入 - MakeLeaps',
    youCurrentlyHave: '現在の郵送ポイント: {{mailpoints}}',
};
